import { render } from "./editcampaign.vue?vue&type=template&id=038ec54f&scoped=true"
import script from "./editcampaign.vue?vue&type=script&lang=js"
export * from "./editcampaign.vue?vue&type=script&lang=js"

import "./editcampaign.vue?vue&type=style&index=0&id=038ec54f&scoped=true&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038ec54f"]])

export default __exports__